import {
  CardContainer,
  CardKey,
  CardTitle,
  CardValue,
} from '../../StyledComponents/Card';
import CondorSpinner from '../CondorSpinner';
import React from 'react';
import { useFormattedDate } from './useFormattedDate';
import { Tooltip } from '@mui/material';

interface DeviceInfoProps {
  loading: boolean;
  deviceDetails?: {
    canopyDeviceId?: string | null;
    lifecycleState?: string | null;
    batteryLevel?: number | null;
    lastConnected?: string | null;
    pendingOta?: {
      version?: string | null;
      status?: string | null;
    } | null;
    deviceReportedVersion?: string | null;
    vehicle: {
      isInMotion?: boolean | null;
      updatedAt?: string | null;
    };
  };
}

export const DeviceInfo = (props: DeviceInfoProps) => {
  const { loading, deviceDetails } = props;
  const { formattedDate } = useFormattedDate();
  const formatDate = (date?: string | null) => {
    if (date) {
      return formattedDate(date);
    }
    return 'Unknown';
  };
  return (
    <CardContainer>
      <CardTitle>Deployment Related Device Info</CardTitle>
      {loading ? (
        <CondorSpinner />
      ) : (
        <div style={{ display: 'flex' }}>
          <div style={{ flexBasis: '50%' }}>
            <CardKey>Thing Name:</CardKey>
            <CardKey>Lifecycle State:</CardKey>
            <CardKey>Battery Level:</CardKey>
            <CardKey>Last Connected:</CardKey>
            <CardKey>Current Vehicle In Motion (VIM) State:</CardKey>
            <CardKey>Pending Ota State:</CardKey>
            <CardKey>Device Reported Version:</CardKey>
          </div>
          <div style={{ flexBasis: '50%' }}>
            <CardValue>{deviceDetails?.canopyDeviceId}</CardValue>
            <CardValue>{deviceDetails?.lifecycleState}</CardValue>
            <CardValue>{deviceDetails?.batteryLevel}</CardValue>
            <CardValue>{formatDate(deviceDetails?.lastConnected)}</CardValue>
            <CardValue>
              {deviceDetails?.vehicle && (
                <Tooltip
                  title={`Last Updated at: ${formatDate(
                    deviceDetails?.vehicle.updatedAt,
                  )}`}
                  placement="top-start"
                >
                  <span style={{ fontSize: '1em' }}>
                    {deviceDetails.vehicle.isInMotion === null ||
                    deviceDetails.vehicle.isInMotion === undefined
                      ? '-'
                      : deviceDetails.vehicle.isInMotion
                      ? 'true'
                      : 'false'}
                  </span>
                </Tooltip>
              )}
            </CardValue>
            <CardValue>
              {deviceDetails?.pendingOta?.version} -{' '}
              {deviceDetails?.pendingOta?.status}
            </CardValue>
            <CardValue>{deviceDetails?.deviceReportedVersion}</CardValue>
          </div>
        </div>
      )}
    </CardContainer>
  );
};
